
























import { Vue, Component, Emit, Watch, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class FilterDifficulty extends Vue {
  @Prop() selectedDifficulty!: string;

  T = T;
  currentDifficulty = this.selectedDifficulty;

  difficulties: { [key: string]: { name: string; id: string } } = {
    anyDifficulty: {
      name: T.qualityFormDifficultyAny,
      id: 'all',
    },
    difficultyEasy: {
      name: T.qualityFormDifficultyEasy,
      id: 'easy',
    },
    difficultyMedium: {
      name: T.qualityFormDifficultyMedium,
      id: 'medium',
    },
    difficultyHard: {
      name: T.qualityFormDifficultyHard,
      id: 'hard',
    },
  };

  @Emit('change')
  @Watch('currentDifficulty')
  onCurrentDifficultyChanged(val: string | null) {
    return val;
  }
}
